type LoginPayloadModel = {
  email: string
  password: string
}

type LoginResponseModel = {
  access_token: string
  id_token: string
}

type RestaurantModel = {
  id: string
  name: string
  currency: string
  defaultLanguageCode: string
}

type RestaurantsListResponseModel = RestaurantModel[]

enum QUERY {
  LOGIN = 'LOGIN',
  RESTAURANTS = 'RESTAURANTS'
}

export type {
  LoginPayloadModel,
  LoginResponseModel,
  RestaurantModel,
  RestaurantsListResponseModel
}
export { QUERY }
